/**
 * Popup video
 */

import $ from "jquery";

import { $document, $win } from "../utils/globals";
import { debounce } from "lodash";

var isAjax = false;
var cartItemsSelector = ".cart__items";
var step2ItemsSelector = ".step-2-items";

// Laad cart asynchroon en alleen als cart elements bestaan
function loadCart() {
	// Check of cart elements bestaan op deze pagina
	if ($("#cart__items").length === 0 && $("#step-2-items").length === 0) {
		return; // Geen cart op deze pagina, skip AJAX call
	}

	const settings = {
		url: resources.ajax,
		data: {
			action: "app_get_cart",
		},
	};

	if (!isAjax) {
		$.ajax(settings)
			.done(function (response) {
				$("#cart__items").replaceWith(response.data.cart_html);
				$("#step-2-items").replaceWith(response.data.step_2_html);

				if ($(cartItemsSelector).hasClass("cart__items--empty")) {
					$(".steps--nav").addClass("hidden");
				} else {
					$(".steps--nav").removeClass("hidden");
				}
			})
			.fail(function (error) {
				console.log("Error:" + error);
			});
	}
}

// Laad cart non-blocking na DOMContentLoaded
if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", function () {
		// Gebruik requestIdleCallback voor optimale performance
		if ("requestIdleCallback" in window) {
			requestIdleCallback(loadCart, { timeout: 2000 });
		} else {
			setTimeout(loadCart, 0);
		}
	});
} else {
	// DOM is al geladen
	if ("requestIdleCallback" in window) {
		requestIdleCallback(loadCart, { timeout: 2000 });
	} else {
		setTimeout(loadCart, 0);
	}
}

$document.on(
	"change",
	".form-quantity input.form__input-qty",
	debounce(function (e) {
		const $this = $(this);
		let $cartItem = $this.closest(".form-quantity");

		const settings = {
			url: resources.ajax,
			data: {
				action: "app_add_to_cart",
				product_id: $cartItem.data("product-id"),
				qty: $this.val(),
				set: true,
			},
			beforeSend: function () {
				isAjax = true;
			},
		};

		if (!isAjax) {
			$.ajax(settings)
				.done(function (response) {
					$(cartItemsSelector).replaceWith(response.data.cart_html);
					$(step2ItemsSelector).replaceWith(response.data.step_2_html);

					if ($(cartItemsSelector).hasClass("cart__items--empty")) {
						$(".steps--nav").addClass("hidden");
					} else {
						$(".steps--nav").removeClass("hidden");
					}
				})
				.fail(function (error) {
					console.log("Error:" + error);
				})
				.complete(function () {
					isAjax = false;
				});
		}
	}, 500)
);

$document.on("click", ".js-btn-remove", function (e) {
	e.preventDefault();
	let $this = $(this);
	let $cartItem = $this.closest(".form-quantity");

	const settings = {
		url: resources.ajax,
		data: {
			action: "app_remove_from_cart",
			product: $cartItem.data("product-id"),
		},
		beforeSend: function () {
			isAjax = true;
		},
	};

	if (!isAjax) {
		$.ajax(settings)
			.done(function (response) {
				$(cartItemsSelector).replaceWith(response.data.cart_html);
				$(step2ItemsSelector).replaceWith(response.data.step_2_html);

				if ($(cartItemsSelector).hasClass("cart__items--empty")) {
					$(".steps--nav").addClass("hidden");
				} else {
					$(".steps--nav").removeClass("hidden");
				}
			})
			.fail(function (error) {
				console.log("Error:" + error);
			})
			.complete(function () {
				isAjax = false;
			});
	}
});


$document.on("click", ".sub-menu .menu-item", function (e) {
	function deleteCookie(name) {
		document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/';
	}
	deleteCookie('shop_cart');
})
